import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext"; // Import AuthContext
import api from "../utils/api"; // Import API utility
import AccountSidebar from "./AccountSidebar";

const UpdateProfile = () => {
  const { token } = useAuth(); // Access token from AuthContext
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    userId: "", // Add userId to formData
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // Fetch user data on component mount
  const fetchUserData = async () => {
    try {
      const response = await api.get("/users/me", {
        headers: {
          Authorization: `Bearer ${token}`, // Pass token in Authorization header
        },
      });

      const userData = response.data;
      setFormData({
        fullName: userData.fullName || "",
        email: userData.email || "",
        password: "", // Leave password field empty
        userId: userData._id || "", // Store user ID for updating
      });
      setMessage(""); // Clear any previous messages
      setError(""); // Clear any previous errors
    } catch (err) {
      setError(err.response?.data?.error || "Failed to fetch user data.");
    }
  };

  useEffect(() => {
    if (token) fetchUserData(); // Fetch data if token exists
  }, [token]);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSaveChanges = async (e) => {
    e.preventDefault();
    setMessage(""); // Reset message
    setError(""); // Reset error

    if (!formData.fullName) {
      setError("Full Name is required.");
      return;
    }

    try {
      const dataToUpdate = {
        fullName: formData.fullName,
        ...(formData.password && { password: formData.password }), // Only include password if provided
      };

      const response = await api.put(`/users/${formData.userId}`, dataToUpdate, {
        headers: {
          Authorization: `Bearer ${token}`, // Pass token in Authorization header
        },
      });

      setMessage("Profile updated successfully!");
      setFormData({ ...formData, password: "" }); // Clear password field
    } catch (err) {
      setError(err.response?.data?.error || "An error occurred while updating the profile.");
    }
  };

  return (
    <>
     
      <div className="flex">
        {/* Sidebar */}
        <AccountSidebar />




        {/* Profile Form */}
        <div className="w-full ml-10 p-8  bg-primary rounded-lg shadow-lg font-inter mt-10">
          {/* Success or Error Messages */}
          {message && <div className="text-green-500 mb-4">{message}</div>}
          {error && <div className="text-red-500 mb-4">{error}</div>}

          <form onSubmit={handleSaveChanges} className="space-y-6">
            {/* Full Name */}
            <div>
              <label className="block text-sm font-medium mb-1 text-black">Full Name</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                className="w-full px-4 py-2 rounded-lg bg-black text-yellow-300 focus:outline-none focus:ring focus:ring-yellow-400"
              />
            </div>

            {/* Email (Read-Only) */}
            <div>
              <label className="block text-sm font-medium mb-1 text-black">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                className="w-full px-4 py-2 rounded-lg bg-black text-yellow-300 focus:outline-none"
                readOnly
              />
            </div>

            {/* Password */}
            <div>
              <label className="block text-sm font-medium mb-1 text-black">Password</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full px-4 py-2 rounded-lg bg-black text-white focus:outline-none focus:ring focus:ring-yellow-400"
                placeholder="Enter a new password"
              />
            </div>

            {/* Buttons */}
            <div className="flex justify-between">
              <button
                type="button"
                onClick={() => setFormData({ ...formData, password: "" })} // Reset password field
                className="bg-black text-primary px-4 py-2 rounded-lg hover:bg-gray-800"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="bg-black text-primary px-4 py-2 rounded-lg hover:bg-gray-800"
              >
                Save Changes
              </button>
            </div>


          </form>

        </div>
        <div className="hidden lg:block lg:w-1/4 lg:bg-black lg:px-6 lg:py-10 lg:text-right">
          <h3 className="text-lg font-bold font-inter text-primary">
            Hello {formData.fullName}
          </h3>
        </div>

      </div>
    </>
  );
};

export default UpdateProfile;
